import { render, staticRenderFns } from "./CMSBannerCount.vue?vue&type=template&id=971eab0a&lang=pug"
import script from "./CMSBannerCount.vue?vue&type=script&lang=js"
export * from "./CMSBannerCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports